import { Injectable, ɵbypassSanitizationTrustResourceUrl } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastr: ToastrService) {
    toastr.toastrConfig.enableHtml = true;        
   }

  showSuccess(message, title) {
      this.toastr.success(message, title);
  }

  showError(message, title) {
    this.toastr.error(message, title);
    //"The server can not find the requested page.&#10;Status code: 404"

  }

  showInfo(message, title) {
    this.toastr.info(message, title);
  }

  showWarning(message, title) {
    this.toastr.warning(message, title);
  }
}
